document.getElementById("dealerForm").addEventListener("submit", async function(event) {
  event.preventDefault();
  const form = this;

  document.getElementById("dealer-spinner").style.display = "block";
  form.style.display = "none";
  document.getElementById("dealer-successMessage").style.display = "none";
  document.getElementById("dealer-errorMessage").style.display = "none";

  const submitButton =
    document.getElementById('dealerSubmit') ||
    form.querySelector('button[type="submit"], input[type="submit"]');

  if (submitButton) submitButton.setAttribute('disabled', 'disabled');

  try {
    const captchaToken = form.querySelector('input[name="cf-turnstile-response"]')?.value || "";
    if (!captchaToken) {
      throw new Error("Please complete the CAPTCHA challenge.");
    }

    const formData = new FormData(form);
    const obj = {};

    formData.forEach((value, key) => {
      if (key === "brands") {
        if (!obj[key]) obj[key] = [];
        obj[key].push(value);
      } else {
        obj[key] = value;
      }
    });

    obj["cf-turnstile-response"] = captchaToken;

    const response = await fetch("https://portal.lanesharkusa.com/api/public/dealer-form-shopify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj)
    });

    if (!response.ok) throw new Error("Network response was not ok");

    let payload;
    const ct = (response.headers.get("content-type") || "").toLowerCase();
    if (ct.includes("application/json")) {
      payload = await response.json();
    } else {
      payload = await response.text();
      payload = { message: payload };
    }

    document.getElementById("dealer-spinner").style.display = "none";
    if (submitButton) submitButton.removeAttribute('disabled');

    if (payload.message === "success") {
      form.style.display = "none";
      document.getElementById("dealer-successMessage").style.display = "block";
    document.getElementById("dealer-successMessage").focus(); // a11y: move focus to the result
    } else {
      throw new Error("Unexpected server response");
    }

  } catch (error) {
    console.error("Error:", error);

    document.getElementById("dealer-spinner").style.display = "none";
    document.getElementById("dealer-errorMessage").style.display = "block";
    document.getElementById("dealer-errorMessage").focus(); // a11y: move focus to the result
    form.style.display = "";

  } finally {
    if (submitButton) submitButton.removeAttribute('disabled');
    window.turnstile?.reset?.();
  }
});